import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./components/routes/AppRoutes";
import { LoaderProvider } from "../pages/LoaderContext";
import Loader from "../pages/Loader";


import { AuthProvider } from '../msal/AuthProvider';
import SSOAuthenticator from '../msal/SSOAuthenticator';
import { useAppContext } from '../hooks/context/AppContext';
import { FiltersProvider } from "../hooks/context/FiltersContext";
import FeedbackButton from "./pages/FeedbackButton";


const AppV2: React.FC = () => {
  const { error, updateError } = useAppContext();

  return (
    <>
        <AuthProvider>
          <LoaderProvider>
           
              <SSOAuthenticator>
                <FiltersProvider>
                  <Loader /> 
                  <AppRoutes />
                  <FeedbackButton />
                </FiltersProvider>
              </SSOAuthenticator>
           
          </LoaderProvider>
        </AuthProvider>
    </>

  );
};

export default AppV2;

